import { VehicleAllocation } from '@/types/vehicleAllocation'

export const sortAlphanumeric = (a: VehicleAllocation, b: VehicleAllocation) => {
    return a.route.localeCompare(b.route, undefined, { numeric: true, sensitivity: 'base' })
}
